import React from "react";
import "../../styles/AboutUs.css";
import aboutImage from "../../assets/about.png";

export default function AboutUsSection() {
  return (
    <section id="about" className="about-section">
      <div className="about-container">
        <div className="about-image">
          <img src={aboutImage} alt="About Medamos Pharma" />
        </div>
        <div className="about-text">
          <h2>About Us</h2>
          <p>
            Medamos Life Sciences Private Limited is a renowned manufacturer and supplier of active pharmaceutical ingredients (API), High End Intermediates, Nutraceuticals, and other Diagnostic Solutions that are used in the production of various pharmaceutical products.
          </p>
          <p>
            With an Indian soul and a global vision, Medamos Life Sciences has emerged as a leading player in the chemical industry. Our products are known for their high quality and cost - effectiveness, making them an ideal choice for pharmaceutical companies looking to produce high - quality products while keeping the costs in check.
          </p>
        </div>
      </div>
    </section>
  );
}

